"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubtitleSeparator = exports.InfoListItemChevron = exports.RightComponent = exports.Info = exports.Subtitle = exports.InfoListItemText = exports.Icon = exports.InfoListItemDivider = exports.StatusStripe = exports.InfoListItemContentContainer = exports.Root = void 0;
var ListItem_1 = __importDefault(require("@mui/material/ListItem"));
var styles_1 = require("@mui/material/styles");
var color_1 = __importDefault(require("color"));
var Colors = __importStar(require("@brightlayer-ui/colors"));
var ListItemButton_1 = __importDefault(require("@mui/material/ListItemButton"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Divider_1 = __importDefault(require("@mui/material/Divider"));
var Avatar_1 = __importDefault(require("@mui/material/Avatar"));
var ListItemText_1 = __importDefault(require("@mui/material/ListItemText"));
var ChevronRight_1 = __importDefault(require("@mui/icons-material/ChevronRight"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
exports.Root = (0, styles_1.styled)(ListItem_1.default, {
    shouldForwardProp: function (prop) {
        return prop !== 'iconColor' &&
            prop !== 'iconColor' &&
            prop !== 'backgroundColor' &&
            prop !== 'wrapSubtitle' &&
            prop !== 'wrapTitle' &&
            prop !== 'wrapInfo' &&
            prop !== 'ripple';
    },
})(function (_a) {
    var onClick = _a.onClick, backgroundColor = _a.backgroundColor, wrapSubtitle = _a.wrapSubtitle, wrapTitle = _a.wrapTitle, wrapInfo = _a.wrapInfo, dense = _a.dense, ripple = _a.ripple, theme = _a.theme;
    var isWrapEnabled = function () { return wrapSubtitle || wrapTitle || wrapInfo; };
    var getHeight = function () { return (dense ? "3.5rem" : "4.5rem"); };
    var isCssColor = true;
    try {
        (0, color_1.default)(backgroundColor);
    }
    catch (e) {
        isCssColor = false;
    }
    return {
        cursor: onClick ? 'pointer' : 'inherit',
        backgroundColor: backgroundColor || 'inherit',
        minHeight: isWrapEnabled() ? getHeight() : 'initial',
        height: !isWrapEnabled() ? getHeight() : 'auto',
        '&:hover': {
            backgroundColor: onClick
                ? backgroundColor && backgroundColor !== 'inherit' && backgroundColor !== 'transparent' && isCssColor
                    ? (0, color_1.default)(backgroundColor).darken(0.08).string()
                    : theme.palette.action.hover
                : undefined,
        },
        '&:focus': {
            outline: 'none',
        },
        padding: onClick && ripple ? 0 : undefined,
        paddingTop: isWrapEnabled() ? '0' : undefined,
        paddingBottom: isWrapEnabled() ? '0' : undefined,
        '& .MuiListItemButton-root': {
            minHeight: isWrapEnabled() ? getHeight() : 'initial',
            height: !isWrapEnabled() ? getHeight() : 'auto',
            paddingTop: isWrapEnabled() ? '0' : undefined,
            paddingBottom: isWrapEnabled() ? '0' : undefined,
        },
        '& .MuiListItemText-dense': {
            marginTop: 0,
            marginBottom: 0,
        },
    };
});
exports.InfoListItemContentContainer = (0, styles_1.styled)(ListItemButton_1.default)(function () { return ({
    height: 'inherit',
    width: 'inherit',
}); });
exports.StatusStripe = (0, styles_1.styled)(Box_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'statusColor'; },
})(function (_a) {
    var statusColor = _a.statusColor;
    return ({
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        width: 6,
        zIndex: 100,
        backgroundColor: statusColor,
    });
});
exports.InfoListItemDivider = (0, styles_1.styled)(Divider_1.default)(function (_a) {
    var divider = _a.divider, theme = _a.theme;
    return ({
        position: 'absolute',
        bottom: 0,
        right: theme.direction === 'rtl' ? (divider === 'full' ? 0 : "4.5rem") : 0,
        left: theme.direction === 'ltr' ? (divider === 'full' ? 0 : "4.5rem") : 0,
        zIndex: 0,
    });
});
exports.Icon = (0, styles_1.styled)(Avatar_1.default, {
    shouldForwardProp: function (prop) {
        return prop !== 'statusColor' &&
            prop !== 'iconColor' &&
            prop !== 'iconAlign' &&
            prop !== 'avatar' &&
            prop !== 'isInvisible';
    },
})(function (_a) {
    var statusColor = _a.statusColor, iconColor = _a.iconColor, avatar = _a.avatar, iconAlign = _a.iconAlign, isInvisible = _a.isInvisible, theme = _a.theme;
    var getIconColor = function () {
        if (iconColor)
            return iconColor;
        if (avatar) {
            return statusColor
                ? (0, color_1.default)(statusColor).isDark()
                    ? Colors.white[50]
                    : Colors.black[500]
                : Colors.white[50]; // default avatar is dark gray -> white text
        }
        return statusColor ? statusColor : theme.palette.text.secondary;
    };
    var getIconAlignment = function () {
        switch (iconAlign) {
            case 'left':
                return 'flex-start';
            case 'right':
                return 'flex-end';
            case 'center':
            default:
                return 'center';
        }
    };
    if (avatar) {
        return {
            backgroundColor: statusColor || Colors.black[500],
            color: getIconColor(),
            width: "2.5rem",
            height: "2.5rem",
            padding: ".5rem",
            marginRight: theme.spacing(2),
        };
    }
    return {
        color: getIconColor(),
        justifyContent: getIconAlignment(),
        backgroundColor: 'transparent',
        overflow: 'visible',
        width: "2.5rem",
        height: "2.5rem",
        marginRight: theme.spacing(2),
        opacity: isInvisible ? 0 : 'auto',
    };
});
exports.InfoListItemText = (0, styles_1.styled)(ListItemText_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'leftComponent'; },
})(function (_a) {
    var leftComponent = _a.leftComponent, theme = _a.theme;
    return ({
        // we have to specify both here because the auto-swap from JSS isn't smart enough to do it when we use a function
        marginLeft: leftComponent ? (theme.direction === 'rtl' ? 0 : theme.spacing(2)) : 0,
        marginRight: leftComponent ? (theme.direction === 'rtl' ? theme.spacing(2) : 0) : 0,
    });
});
exports.Subtitle = (0, styles_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'fontColor'; },
})(function (_a) {
    var fontColor = _a.fontColor, theme = _a.theme;
    return ({
        fontWeight: 400,
        lineHeight: 1.3,
        color: fontColor || (theme.palette.mode === 'dark' ? theme.palette.text.secondary : 'inherit'),
    });
});
exports.Info = (0, styles_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'fontColor'; },
})(function (_a) {
    var fontColor = _a.fontColor, theme = _a.theme;
    return ({
        fontWeight: 400,
        lineHeight: 1.3,
        color: fontColor || (theme.palette.mode === 'dark' ? theme.palette.text.secondary : 'inherit'),
    });
});
exports.RightComponent = (0, styles_1.styled)(Box_1.default, {})(function (_a) {
    var theme = _a.theme;
    return ({
        flex: '0 0 auto',
        marginLeft: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
    });
});
exports.InfoListItemChevron = (0, styles_1.styled)(ChevronRight_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'chevronColor'; },
})(function (_a) {
    var chevronColor = _a.chevronColor, theme = _a.theme;
    return ({
        color: chevronColor ? chevronColor : theme.palette.text.secondary,
        transform: theme.direction === 'rtl' ? 'scaleX(-1)' : '',
    });
});
exports.SubtitleSeparator = (0, styles_1.styled)(Typography_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'inline-block',
        lineHeight: 1.3,
        color: 'inherit',
        margin: "0 ".concat(theme.spacing(0.5)),
    });
});
